<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="90px" :rules="rules">
      <el-form-item label="设备类型" prop="device_type_id">
        <el-select v-model="ruleForm.device_type_id" placeholder="选择设备类型">
          <el-option
            v-for="item in deviceTypeList"
            :key="item.device_type_id"
            :label="item.device_type_name"
            :value="item.device_type_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备型号" prop="device_model_name">
        <el-input v-model="ruleForm.device_model_name" maxlength="20" show-word-limit />
      </el-form-item>
      <el-form-item>
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog cz" @click="resetForm">重置</el-button>
        <el-button class="btn_dialog qd" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'

export default {
  data () {
    return {
      service: 'device_model',
      ruleForm: {
        device_type_id: '',
        device_model_name: ''
      },
      rules: {
        device_type_id: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        device_model_name: [
          { required: true, message: '请输入设备型号', trigger: 'blur' }
        ]
      }
    }
  },

  props: ['deviceTypeList'],

  methods: {
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    confirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          Backend.insertRow(this, this.ruleForm, undefined, '设备型号')
        }
      })
    }
  }
}
</script>
